import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'

import './common/directives/select'
import './common/directives/datepicker'
import './common/directives/canaccess'
import './common/directives/htmleditor'

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue);

import Notifications from 'vue-notification'
Vue.use(Notifications)

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

import VueMask from 'di-vue-mask'
Vue.use(VueMask);

import VueNumeric from 'vue-numeric'
Vue.use(VueNumeric)

import money from 'v-money'
Vue.use(money)

import tinymce from 'vue-tinymce-editor'
Vue.component('tinymce', tinymce)

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/custom.scss'

Vue.config.productionTip = false

Vue.prototype.$eventHub = new Vue();

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
